
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/payment",
      function () {
        return require("private-next-pages/checkout/payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/payment"])
      });
    }
  